import React, { useState } from 'react';
import PropTypes from "prop-types";
import { useForm } from 'react-hook-form'
import { useBlockSeat, useChangeMonitor } from '../../common/hooks'
import { toastTimeout } from '../../common/constants';
import { Toast } from '../../common/components';
import "./DialogBox/DialogBox.css";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/common/components/ui/dialog'
import { Button } from '@/common/components/ui/button'

const toastInitialState = { show: false, message: '' }

export default function ManageSeat({ show, onClose, data, handleToast: notifyParent }) {
  const [toast, setToast] = useState(toastInitialState);
  const { handleSubmit } = useForm({ shouldUseNativeValidation: true });
  const [officeName, setOfficeName] = useState('1');
  const [seatNumbers, setSeatNumbers] = useState('');
  const [monitorNumber, setMonitorNumber] = useState('');
  const [manageSeatOps] = useBlockSeat();
  const [manageMonitorOps] = useChangeMonitor();

  const createToastTimeout = () => setTimeout(() => setToast(toastInitialState), toastTimeout)
  const handleError = (error) => setToast({
    show: true,
    message: <>Error managing seat: <span className="text-red-600">{error.message}</span>.</>
  })
  const handleChangeOffice = (e) => setOfficeName(e.target.value)
  const handleChangeSeatNumber = (e) => setSeatNumbers(e.target.value)
  const handleChangeMonitors = (e) => setMonitorNumber(parseInt(e.target.value))

  const manageSeatStatus = (status) => {
    manageSeatOps(officeName, seatNumbers.split(',').map(i => Number(i)), status).then(
      () => {
        notifyParent(<>Seat Number '<strong>{seatNumbers}</strong>' is successfully {status ? 'unblocked' : 'blocked'}</>)
        onClose()
      },
      handleError
    ).finally(createToastTimeout)
  }

  const manageMonitorChange = () => {
    manageMonitorOps(officeName, seatNumbers.split(',').map(i => Number(i)), monitorNumber).then(
      () => {
        notifyParent(<>Seat Number '<strong>{seatNumbers}</strong>' has been successfully changed to have '<strong>{monitorNumber}</strong>' monitors</>)
        onClose()
      },
      handleError
    ).finally(createToastTimeout)
  }

  return (
    <>
      <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Manage Seat</DialogTitle>
          </DialogHeader>
          <div className="BaseInput">
            <form id="seatNumber" name="update seat form" onSubmit={handleSubmit()}>
              <select value={officeName} onChange={handleChangeOffice}>
                {data.offices.map((office) => (
                  <option key={office.id} value={office.id}>{office.location}</option>
                ))}
              </select>
              <div className="InputContainer">
                <input
                  type="text"
                  onChange={handleChangeSeatNumber}
                  placeholder="Enter Seat number here"
                  required
                />
                <button type="button" className="InfoButton">
                  <svg width="16" height="16" fill="#6c757d" className="bi bi-info" viewBox="0 0 16 16">
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                  </svg>
                </button>
                <div className="hide">You can enter multiple seat numbers using comma. eg: 1,2,3</div>
              </div>
              <div className="monitors mt-3">
                <input
                  type="number"
                  onChange={handleChangeMonitors}
                  placeholder="Enter number of monitors here"
                  required
                />
              </div>
            </form>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => manageSeatStatus(false)}>Block Seat</Button>
            <Button variant="outline" onClick={() => manageSeatStatus(true)}>Unblock Seat</Button>
            <Button onClick={manageMonitorChange}>Change Monitors</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <Toast visibility={toast.show}>{toast.message}</Toast>
    </>
  )
}

ManageSeat.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    offices: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      location: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  handleToast: PropTypes.func.isRequired,
}
